export const providerConfig = {
  defaultLanguage: 'sk',
  languages: ['en', 'es', 'pl', 'sk'],
  productName: 'Online ochrana'
};
